module.exports = __webpack_public_path__ + "img/Frame_35.9edc5fe1.png";